import type { File } from '@/components/Views/Company/File/file.types';
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

export const usePayoffNavigation = () => {
    const route = useRoute();
    const router = useRouter();

    const fileId = computed<File['id']>(() => Number(route.query.fileId));

    const navigateToFiles = (fileId: File['id']) => {
        router.push(`/user/files/${fileId}`);
    };

    return {
        fileId,
        navigateToFiles,
    };
};
